import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';

import { getAutoSuggests } from '@/modules/search/domain/resources/getAutoSuggests';
import { getPopularPrograms } from '@/modules/search/domain/resources/getPopularPrograms';
import { getSearchResults } from '@/modules/search/domain/resources/getSearchResults';

export const useSearch = ({
  autoSuggestvalue,
  searchText,
}: {
  autoSuggestvalue: string;
  searchText: string;
}) => {
  const { data: searchPopularPrograms = [], isLoading: isLoadingPopularPrograms } = useQuery(
    ['popular-programs'],
    getPopularPrograms,
    {
      staleTime: Infinity,
    }
  );

  const { data: searchAutoSuggestList = [] } = useQuery(
    ['auto-suggests', autoSuggestvalue],
    () => autoSuggestvalue && getAutoSuggests(autoSuggestvalue),
    {
      staleTime: Infinity,
    }
  );

  const {
    isLoading: isLoadingSearch,
    data: searchResults,
    error: errorFetchSearchResults,
  } = useQuery(['search-results', searchText], () => searchText && getSearchResults(searchText), {
    staleTime: Infinity,
  });

  return {
    isLoadingPopularPrograms,
    isLoadingSearch,
    searchPopularPrograms,
    // Locally, searchAutoSuggestList is an empty object
    searchAutoSuggestList: isEmpty(searchAutoSuggestList) ? [] : searchAutoSuggestList,
    searchResults,
    errorFetchSearchResults,
  };
};
